// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/components/ActionButtons/BulkAdicionarVerbaButton/BulkAdicionarVerbaButton.tsx

import React from 'react';
import { TEXTO_DA_MASSA } from '../../../verbaEmMassa';
import styles from './BulkAdicionarVerbaButton.module.scss';

export interface BulkAdicionarVerbaButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Abre o modal que aplica verba de sell-in aos itens marcados.
 *
 * Vive no mesmo grupo de ações em massa que aprovar e recusar, e segue a mesma habilitação por
 * seleção.
 *
 * **O rótulo é fixo, sem interpolação:** a contagem da seleção já está na barra, à esquerda.
 */
export const BulkAdicionarVerbaButton: React.FC<BulkAdicionarVerbaButtonProps> = ({ onClick, disabled = false, className = '' }) => (
  <button className={`${styles['bulk-adicionar-verba-button']} ${className}`} onClick={onClick} disabled={disabled} type="button">
    {TEXTO_DA_MASSA.ROTULO_DO_BOTAO}
  </button>
);
